<template>
	<div>
		<el-row class="contents">
			<!-- 查询条件 -->
			<el-col :span="24" class="handleQuery">
				<el-form :inline="true" :model="queryParams" class="form" size="small" label-width="100px" style="margin: 0px;margin-left:10px;margin-top:10px;">
					<el-form-item>
						<el-button type="primary" size="small" @click="handleBack">返回</el-button>
					</el-form-item>
				</el-form>
			</el-col>

			<!-- 列表 -->
			<el-col :span="24">
				<el-table v-loading="loading" :data="datas" stripe border style="width: 100%" ref="multipleTable" tooltip-effect="dark" @selection-change="handleSelectionChange"
					@sort-change="sortChange" :default-sort="queryParams.defaultSort">
					<el-table-column prop="title" label="消息主题"></el-table-column>
					<el-table-column prop="message" label="消息内容">
						<template slot-scope="scope">
							<div  v-html="scope.row.message"></div>
						</template>
					</el-table-column>
					<el-table-column prop="updateTime" label="发送机构"></el-table-column>
					<el-table-column prop="creatorName" label="发送人"></el-table-column>
					<el-table-column prop="createTime" label="发送时间"></el-table-column>
					<el-table-column fixed="right" label="操作" width="80">
						<template slot-scope="scope">
							<el-button size="mini" type="primary" @click="handleEdit(scope.row)">查看</el-button>
						</template>
					</el-table-column>
				</el-table>

				<!-- 分页 -->
				<el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 30, 50, 100]" :current-page="queryParams.currentPage"
					:page-size="queryParams.pageSize" :total="totalNum" @size-change="pageSizeChange" @current-change="pageCurrentChange"></el-pagination>
			</el-col>
		</el-row>

		<!-- 新增/修改 -->
		<el-dialog title="查看消息" :visible.sync="dialogVisible" width="1000px" :close-on-click-modal="false">
			<el-card class="box-card" style="max-height: 550px;overflow-y: auto;">
			  <div slot="header" class="clearfix">
			    <span>{{addOrUpdateForm.title}}</span>
			    <span style="float: right; padding: 3px 0" type="text">{{addOrUpdateForm.createTime}}</span>
			  </div>
				<div v-html="addOrUpdateForm.message"></div>
			</el-card>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="dialogVisible = false">确 认</el-button>
			</div>
		</el-dialog>


	</div>
</template>

<script>
	import BaseSearch from '@/components/layout/base/base-search-front';
	import common from '@/common/common.js';
	import {
		quillEditor,
		Quill
	} from 'vue-quill-editor'
	import {
		container,
		ImageExtend
	} from 'quill-image-extend-module'

	Quill.register('modules/ImageExtend', ImageExtend)

	// require styles 引入样式
	import 'quill/dist/quill.core.css'
	import 'quill/dist/quill.snow.css'
	import 'quill/dist/quill.bubble.css'

	import ImageResize from 'quill-image-resize-module';
	Quill.register('modules/imageResize', ImageResize)
	import {
		ImageDrop
	} from '@/components/libs/ImageDrop.js';
	Quill.register('modules/imageDrop', ImageDrop)

	const toolbarOptions = [
		['bold', 'italic', 'underline', 'strike'], // toggled buttons
		[{
			'header': 1
		}, {
			'header': 2
		}], // custom button values
		[{
			'list': 'ordered'
		}, {
			'list': 'bullet'
		}],
		[{
			'indent': '-1'
		}, {
			'indent': '+1'
		}], // outdent/indent
		[{
			'direction': 'rtl'
		}], // text direction
		[{
			'size': ['small', false, 'large', 'huge']
		}], // custom dropdown
		[{
			'header': [1, 2, 3, 4, 5, 6, false]
		}],
		[{
			'color': []
		}, {
			'background': []
		}], // dropdown with defaults from theme
		[{
			'font': []
		}],
		[{
			'align': []
		}],
		['link', 'image'],
		['clean']

	]

	import axios from 'axios'


	export default {
		extends: BaseSearch,
		components: {
			quillEditor
		},
		data() {
			return {
				url: 'mngr/cm/message',
				name: '后台消息',
				institutionList: [],
				rules: {
					title: [{
							required: true,
							message: '请输入标题',
							trigger: 'blur'
						},
						{
							max: 50,
							message: '长度最长支持50',
							trigger: 'blur'
						}
					],
					institutionIds: [{
						required: true,
						message: '请选择发送机构',
						trigger: 'blur',
						validator: this.checkArrayNotEmpty
					}, ],
					secondNum: [{
							required: true,
							message: '请输入定时关闭秒数',
							trigger: 'blur'
						},
						{
							max: 11,
							message: '长度最长支持11',
							trigger: 'blur'
						}
					],
				},
				editorOption: {
					placeholder: '',
					theme: 'snow', // or 'bubble'
					modules: {
						/* ImageExtend: {
							loading: true,
							name: 'file',
							action: '/api/system/file/upload',
							headers: xhr => { // 设置请求头参数
								xhr.setRequestHeader('Token', sessionStorage.getItem('token'))
							},
							response: (res) => {
								return response.data
							}
						}, */
						imageDrop: {
							that: this,
							fileUrl: axios.defaults.fileURL
						},
						imageResize: {},
						toolbar: {
							container: container,
							handlers: {
								'image': function(value) {
									if (value) {
										// 触发input框选择图片文件
										document.querySelector('.avatar-uploader input').click()
									} else {
										this.quill.format('image', false);
									}
								}
							}
						}
					}
				},
				quillUpdateImg: false,
				checked: false, // el-checkbox 是否勾选上
				indeterminate: false, // el-checkbox 的 indeterminate 属性为true时用以表示 checkbox 的不确定状态
				headers:{}
			};
		},
		filters: {},
		methods: {
			handleBack(){
				common.routerPush(this, '/home')
			},
			checkArrayNotEmpty(rule, value, callback) {
				value =this.addOrUpdateForm[rule.field]
				if (value && value.length > 0) {
					callback();
				} else {
					callback(new Error(rule.message));
				}
			},
			createUpdateForm(row) {
				if (row) {
					var newObj = Object.assign({}, row); //复制对象, 避免表单与表格数据 双向绑定
					this.addOrUpdateForm = newObj;
					this.selectChange(this.addOrUpdateForm.institutionIds)
				} else {
					this.checked= false
					this.indeterminate= false
					this.addOrUpdateForm = {
						institutionIds:[],
						secondNum:0
					};
				}
			},
			beforeUpdate() {},
			queryInstitutionList() {
				let that = this;
				this.$http({
					method: 'POST',
					url: 'institution/query',
					data: {
						currentPage: 1,
						pageSize: 100,
					},
				}).then(function(res) {
					that.institutionList = res.data.data;
				})
			},
			selectAll() {
				this.indeterminate = false;
				let selectedData = [];
				if (this.checked) {
					this.institutionList.forEach((item) => {
						selectedData.push(item.id);
					});
				}
				this.addOrUpdateForm.institutionIds = selectedData;
				this.$refs['addOrUpdateForm'].clearValidate();
			},
			selectChange(val) {
				// 全选
				if (val.length === this.institutionList.length) {
					this.checked = true;
					this.indeterminate = false;
				} else if (val.length < this.institutionList.length && val.length > 0) {
					this.checked = false;
					this.indeterminate = true;
				} else {
					this.checked = false;
					this.indeterminate = false;
				}
				if(this.$refs['addOrUpdateForm']){
					this.$refs['addOrUpdateForm'].clearValidate();
				}
			},
			onEditorChange({
				editor,
				html,
				text
			}) { //内容改变事件
				console.log("---内容改变事件---")
				this.content = html
				console.log(html)
			},
			// 富文本图片上传前
			beforeUpload() {
				// 显示loading动画
				this.quillUpdateImg = true
			},
			
			uploadSuccess(response, file) {
				// res为图片服务器返回的数据
				// 获取富文本组件实例
				if (response.errorCode == '0000') {
					// 如果上传成功
					if (response.errorCode == '0000') {
						// 获取光标所在位置
						let quill = this.$refs.myQuillEditor.quill
						let length = quill.getSelection().index;
						// 插入图片  res.url为服务器返回的图片地址
						quill.insertEmbed(length, 'image', response.data)
						// 调整光标到最后
						quill.setSelection(length + 1)
					} else {
						this.$message.error('图片插入失败')
					}
					// loading动画消失
					this.quillUpdateImg = false
				} else {
					this.errorMessage("系统提示", response.message);
				}
			
			},
			// 富文本图片上传失败
			uploadError() {
				// loading动画消失
				this.quillUpdateImg = false
				this.$message.error('图片插入失败')
			},
		},
		mounted: function() {
			let token = sessionStorage.getItem('token');
			this.headers.Token = token;
			this.queryInstitutionList()
		}
	};
</script>

<style scoped>
	.el-dialog {
		width: 35% !important;
	}

	/deep/ .ql-editor {
		min-height: 300px
	}
</style>


// WEBPACK FOOTER //
// src/view/front/message/message.vue